<template>
  <DashboardCard
    :readonly="readonly"
    :is-loading="isLoading"
    class="funnel-widget"
    @edit="$emit('edit')"
    @drag="$emit('drag', $event)"
  >
    <template slot="header">
      <WidgetHeader
        :name="argumentsValues.name"
        :metrics="argumentsValues.metrics"
        :external-href="externalHref"
        :profiles="profiles"
        :show-goal-profile-name="false"
        @click="$emit('cancel')"
      />
    </template>
    <template>
      <div
        v-if="data.items.length > 0"
      >
        <FunnelWidgetChart
          :statistics="data.items"
          :metrics="selectedMetrics"
          :metric-type="metricType"
          :is-simple-metric="isSimpleMetric"
          :grouping="dsParams.grouping"
          :color-getter="colorGetter"
          height="240px"
        />
      </div>
      <CardNoDataText
        v-else
      />
    </template>
  </DashboardCard>
</template>

<script>
  import DashboardCard from 'components/Dashboards/Widgets/WidgetMockCards/DashboardCard';
  import FunnelWidgetChart from 'components/Dashboards/Widgets/FunnelWidget/FunnelWidgetChart';
  import CardNoDataText from 'components/Dashboards/Widgets/WidgetMockCards/CardNoDataText';
  import WidgetHeader from 'components/Dashboards/Widgets/WidgetHeader/WidgetHeader';

  export default {
    name: 'FunnelWidget',
    components: {
      CardNoDataText,
      FunnelWidgetChart,
      DashboardCard,
      WidgetHeader
    },
    props: {
      isLoading: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default: Object
      },
      argumentsValues: {
        type: Object,
        default: Object
      },
      dsParams: {
        type: Object,
        default: Object
      },
      metrics: {
        type: Object,
        default: Object
      },
      readonly: Boolean,
      profiles: {
        type: Array,
        default: Array
      },
      externalHref: {
        type: String,
        default: null
      },
      colorGetter: {
        type: Object,
        required: true
      }
    },
    computed: {
      selectedMetrics () {
        return this.argumentsValues.metrics.map(el => {
          let metric = {...this.metrics[el]};

          if (metric.profile_id) {
            let profile = this.profiles.find(x => x.id === metric.profile_id);

            if (profile) {
              if (!metric.goal_id) {
                metric.name = profile.formattedName;
              } else {
                let goal = profile.children.find(x => x.id === metric.goal_id);

                if (goal) {
                  metric.name = goal.formattedName;
                }
              }
              metric.icon = profile.icon;
            }
          }

          return metric;
        });
      },
      isSimpleMetric () {
        return !this.selectedMetrics[0].profile_id && !this.selectedMetrics[0].goal_id;
      },
      metricType () {
        return this.selectedMetrics[0].type;
      }
    }
  };
</script>
